import { AnimatePresence } from 'framer-motion';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './components/Navbar';
import NeuralBackground from './components/NeuralBackground';
import SEO from './components/SEO';
import LandingPage from './pages/LandingPage';

function App() {
  return (
    <Router>
      <SEO
        title="Ramspheld.Dev | AI & Sustainable Tech"
        description="Engineering Ethical AI & Sustainable Tech for Africa"
      />
      <NeuralBackground />
      <div className="min-h-screen bg-transparent">
        <Navbar />
        <AnimatePresence mode="wait">
          <LandingPage key="one-page-home" />
        </AnimatePresence>
      </div>
    </Router>
  );
}

export default App;